import { FormBase } from 'core/components';

export default class LoginForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		return {
			fields: [
				{
					name: 'app',
					label: 'LOGINFORM.IDENTIFIER',
					rules: 'required|string',
				},
				{
					name: 'username',
					label: 'LOGINFORM.USERNAME',
					rules: 'required|string',
				},
				{
					name: 'password',
					label: 'LOGINFORM.PASSWORD',
					type: 'password',
					rules: 'required|string',
				},
				{
					name: 'recaptcha',
					type: 'recaptcha',
				},
			],
		};
	}
}
